import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import api from '../../api';

const months = ['Enero','Febrero','Marzo','Abril','Mayo','Junio','Julio','Agosto','Septiembre','Octubre','Noviembre','Diciembre'];
const years = Array.from({ length: 10 }, (_, i) => new Date().getFullYear() - i);

export default function AdminRevenue() {
  const navigate = useNavigate();
  const [revenue, setRevenue] = useState(0);
  const [totalUsers, setTotalUsers] = useState(0);
  const [selectedMonth, setSelectedMonth] = useState(new Date().getMonth() + 1);
  const [selectedYear, setSelectedYear] = useState(new Date().getFullYear());

  useEffect(() => { load(); }, [selectedMonth, selectedYear]);

  const load = async () => {
    try {
      const r = await api.get('/analytics/admin/revenue', { params: { month: selectedMonth, year: selectedYear } });
      setRevenue(r.data.total_revenue);
      setTotalUsers(r.data.total_active_users);
    } catch (e) { console.error(e); }
  };

  return (
    <>
      <div className="header" style={{ background: '#000' }}>
        <button className="icon-btn" onClick={() => navigate('/admin')}>←</button>
        <h1 className="header-title">Ganancias</h1>
      </div>
      <div className="content-scroll" style={{ background: '#000' }}>
        <div style={{ marginBottom: '16px' }}>
          <div className="label" style={{ color: '#fff', marginBottom: '8px' }}>Mes</div>
          <div style={{ display: 'flex', gap: '8px', flexWrap: 'wrap' }}>
            {months.map((m, i) => (
              <button key={i} className={`period-tab ${selectedMonth === i + 1 ? 'active' : ''}`}
                onClick={() => setSelectedMonth(i + 1)}>{m}</button>
            ))}
          </div>
        </div>
        <div style={{ marginBottom: '24px' }}>
          <div className="label" style={{ color: '#fff', marginBottom: '8px' }}>Año</div>
          <div style={{ display: 'flex', gap: '8px', flexWrap: 'wrap' }}>
            {years.map(y => (
              <button key={y} className={`period-tab ${selectedYear === y ? 'active' : ''}`}
                onClick={() => setSelectedYear(y)}>{y}</button>
            ))}
          </div>
        </div>

        <div style={{ display: 'flex', gap: '16px', marginBottom: '24px' }}>
          <div className="admin-stat-card">
            <span style={{ fontSize: '40px' }}>💰</span>
            <div style={{ fontSize: '28px', fontWeight: '700', color: '#fff', margin: '8px 0' }}>${revenue.toFixed(2)}</div>
            <div style={{ fontSize: '14px', color: '#999' }}>Ganancia Total</div>
          </div>
          <div className="admin-stat-card">
            <span style={{ fontSize: '40px' }}>👥</span>
            <div style={{ fontSize: '28px', fontWeight: '700', color: '#fff', margin: '8px 0' }}>{totalUsers}</div>
            <div style={{ fontSize: '14px', color: '#999' }}>Usuarios Activos</div>
          </div>
        </div>

        <div style={{ background: '#1a1a1a', borderRadius: '12px', padding: '16px', border: '1px solid #333', display: 'flex', gap: '12px', alignItems: 'flex-start' }}>
          <span style={{ fontSize: '24px' }}>ℹ️</span>
          <p style={{ color: '#999', fontSize: '14px', lineHeight: '20px', flex: 1 }}>Las ganancias se calculan sumando el precio de suscripción de todos los usuarios activos que fueron creados antes del mes seleccionado.</p>
        </div>
      </div>
    </>
  );
}
